import type { Theme } from '@mui/material';

export const styles = {
  selectField: (theme: Theme) => ({
    backgroundColor: theme.colors.white,
  }),
};
